import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M10.792 5.667h9.625c1.15 0 2.083.933 2.083 2.083v12c0 1.15-.933 2.083-2.083 2.083H3.083A2.084 2.084 0 0 1 1 19.75V5.083C1 3.933 1.933 3 3.083 3H7.75c.656 0 1.274.309 1.667.833l1.375 1.834zM3.083 4.5a.584.584 0 0 0-.583.583V19.75c0 .322.262.583.583.583h17.334A.584.584 0 0 0 21 19.75v-12a.584.584 0 0 0-.583-.583h-10a.75.75 0 0 1-.6-.3l-1.6-2.134A.582.582 0 0 0 7.75 4.5H3.083z' />
  </svg>
);
